<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="800px"
    >
      <v-card
        shaped
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-cog-outline
          </v-icon> Module Settings
        </h2>
        <v-card-text>
          <v-form>
            <div class="div-style">
              <p class="p-style">
                Settings Reference
              </p>
              <v-textarea
                v-model="moduleSettingsReference"
                disabled
                outlined
                class="reference-field-styling"
                background-color="#CFD8DC"
                auto-grow
              />
            </div>
            <div class="div-style">
              <p class="p-style">
                Module Name:
                <font
                  class="font-style"
                >
                  {{ moduleName }}
                </font>
              </p>
              <v-textarea
                v-model="organizationModuleSettings"
                filled
                class="input-field-styling"
                outlined
                background-color="#CFD8DC"
                label="Edit Settings"
                auto-grow
              />
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="updateOrganizationModuleSettings()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'OrganizationModuleSettingsForm',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      moduleDetails: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        showModal: true,
        organizationModuleSettings: {},
        loading: false,
        moduleSettingsReference: {},
        moduleName: '',
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.showModuleSettings();
    },
    methods: {
      showModuleSettings () {
        this.organizationModuleSettings = JSON.stringify(this.moduleDetails.settings, null, 4);
        this.moduleName = this.moduleDetails.name.toUpperCase();
        this.moduleSettingsReference = JSON.stringify(this.moduleDetails.reference, null, 4);
      },
      async updateOrganizationModuleSettings () {
        this.loading = true;
        const moduleId = this.moduleDetails.id;
        const organizationId = this.$route.params.organizationId;
        const organizationModuleSettings = JSON.parse(this.organizationModuleSettings);
        await this.$store.dispatch('organizations/updateOrganizationModuleSettings', { settings: { settings: organizationModuleSettings }, organizationId: organizationId, moduleId: moduleId })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Organization Module Settings updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('get-organization-module-details');
            this.loading = false;
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.reference-field-styling {
  font-size: 16px;
  font-weight: bold;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
.div-style {
  text-align: center;
}
.p-style {
  font-size: 20px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
}
.font-style {
  font-size: 18px;
  color: #FF3700;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
</style>
